(function () {
  "use strict";
  var root = document.querySelector(".ccshop7");
  if (!root || root.dataset.ccShopPurchaseReady === "true") return;
  root.dataset.ccShopPurchaseReady = "true";

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initializePurchase(scope) {
  var buyTarget = scope.querySelector('[data-ccshop7-buy-target="main"]');


  if (buyTarget) {
    var variantTitle = buyTarget.getAttribute("data-ccshop7-variant-title") || "selected";
    var quantity = buyTarget.querySelector('input[name="quantity"]');
    var decrement = buyTarget.querySelector("[data-ccshop7-quantity-decrement]");
    var increment = buyTarget.querySelector("[data-ccshop7-quantity-increment]");
    var quantityStatus = buyTarget.querySelector("[data-ccshop7-quantity-status]");
    var quantityPresets = Array.prototype.slice.call(
      buyTarget.querySelectorAll("[data-ccshop7-quantity-preset]")
    );
    function numericAttribute(name, fallback) {
      if (!quantity) return fallback;
      var raw = quantity.getAttribute(name);
      var parsed = Number(raw);
      return raw !== null && raw !== "" && Number.isFinite(parsed) ? parsed : fallback;
    }
    var minimum = numericAttribute("min", 1);
    var maximum = numericAttribute("max", Infinity);
    var incrementBy = Math.max(1, numericAttribute("step", 1));
    function normalize(value) {
      var parsed = Number(value);
      if (!Number.isFinite(parsed)) parsed = minimum;
      var aligned = minimum + Math.round((parsed - minimum) / incrementBy) * incrementBy;
      return Math.min(maximum, Math.max(minimum, aligned));
    }
    function dispatchQuantityEvents() {
      quantity.dispatchEvent(new Event("input", { bubbles: true }));
      quantity.dispatchEvent(new Event("change", { bubbles: true }));
    }
    function subscriptionIsSelected() {
      var choice = buyTarget.querySelector("[data-ccshop7-selling-plan-choice]:checked");
      return Boolean(choice && choice.value);
    }
    function updateQuantityUi(value, announce) {
      var current = normalize(value);
      quantity.value = String(current);
      if (decrement) decrement.disabled = current <= minimum;
      if (increment) increment.disabled = current >= maximum;
      quantityPresets.forEach(function (preset) {
        var presetValue = Number(preset.getAttribute("data-ccshop7-quantity-preset"));
        var valid = Number.isFinite(presetValue)
          && presetValue >= minimum
          && presetValue <= maximum
          && (presetValue - minimum) % incrementBy === 0;
        preset.disabled = !valid;
        preset.setAttribute("aria-pressed", String(valid && presetValue === current));
      });
      if (quantityStatus && announce !== false) {
        var bottleWord = current === 1 ? "bottle" : "bottles";
        var unitWord = current === 1 ? "unit" : "units";
        quantityStatus.textContent = current + " " + bottleWord
          + " selected. Add to cart will add " + current + " " + unitWord
          + " of the " + variantTitle + " item."
          + (subscriptionIsSelected() ? " This count repeats with each scheduled delivery." : "");
      }
      return current;
    }
    function setQuantity(value, shouldDispatch) {
      var current = updateQuantityUi(value, true);
      if (shouldDispatch) dispatchQuantityEvents();
      return current;
    }
    if (decrement && quantity) decrement.addEventListener("click", function () {
      setQuantity(normalize(quantity.value) - incrementBy, true);
    });
    if (increment && quantity) increment.addEventListener("click", function () {
      setQuantity(normalize(quantity.value) + incrementBy, true);
    });
    quantityPresets.forEach(function (preset) {
      preset.addEventListener("click", function () {
        setQuantity(preset.getAttribute("data-ccshop7-quantity-preset"), true);
      });
    });
    if (quantity) quantity.addEventListener("change", function () {
      setQuantity(quantity.value, false);
    });

    var sellingPlanFieldset = buyTarget.querySelector("[data-ccshop7-selling-plans]");
    var sellingPlanInput = buyTarget.querySelector("[data-ccshop7-selling-plan-input]");
    var sellingPlanStatus = buyTarget.querySelector("[data-ccshop7-plan-status]");
    var sellingPlanChoices = buyTarget.querySelectorAll("[data-ccshop7-selling-plan-choice]");
    var addButton = buyTarget.querySelector("[data-ccshop7-add-button]");
    if (sellingPlanFieldset) {
      sellingPlanFieldset.hidden = false;
      sellingPlanFieldset.disabled = false;
    }
    function syncSellingPlan() {
      var selected = buyTarget.querySelector("[data-ccshop7-selling-plan-choice]:checked");
      if (!selected || !sellingPlanInput) return;
      sellingPlanInput.value = selected.value || "";
      sellingPlanInput.disabled = !selected.value;
      if (addButton && !addButton.disabled) {
        addButton.textContent = selected.value
          ? addButton.getAttribute("data-ccshop7-subscription-label")
          : addButton.getAttribute("data-ccshop7-one-time-label");
      }
      if (sellingPlanStatus) {
        sellingPlanStatus.textContent = (selected.getAttribute("data-ccshop7-plan-label") || "Purchase option") + " selected.";
      }
      if (quantity) updateQuantityUi(quantity.value, true);
    }
    sellingPlanChoices.forEach(function (choice) { choice.addEventListener("change", syncSellingPlan); });
    if (quantity) updateQuantityUi(quantity.value, true);
    syncSellingPlan();
  }
  }

function initializeGallery(scope) {
     var gallery = scope.querySelector("[data-ccshop7-product-gallery]");
     if (!gallery || gallery.dataset.ccShopGalleryReady === "true") {
       return;
     }
     var stage = gallery.querySelector("[data-ccshop7-gallery-stage]");
     var slides = Array.prototype.slice.call(
       gallery.querySelectorAll("[data-ccshop7-gallery-slide]")
     );
     var thumbs = Array.prototype.slice.call(
       gallery.querySelectorAll("[data-ccshop7-gallery-thumb]")
     );
     var previous = gallery.querySelector("[data-ccshop7-gallery-prev]");
     var next = gallery.querySelector("[data-ccshop7-gallery-next]");
     var current = gallery.querySelector("[data-ccshop7-gallery-current]");
     var total = gallery.querySelector("[data-ccshop7-gallery-total]");
     var lightbox = gallery.querySelector("[data-ccshop7-gallery-lightbox]");
     var lightboxImage = gallery.querySelector(
       "[data-ccshop7-gallery-lightbox-image]"
     );
     var lightboxCaption = gallery.querySelector(
       "[data-ccshop7-gallery-lightbox-caption]"
     );
     var closeLightbox = gallery.querySelector(
       "[data-ccshop7-gallery-close]"
     );
     var lightboxPrevious = gallery.querySelector("[data-ccshop7-lightbox-prev]");
     var lightboxNext = gallery.querySelector("[data-ccshop7-lightbox-next]");
     var lightboxPosition = gallery.querySelector("[data-ccshop7-lightbox-position]");
     var index = 0;
     var touchStartX = null;
     if (!slides.length) {
       return;
     }
     gallery.dataset.ccShopGalleryReady = "true";
     if (total) {
       total.textContent = String(slides.length);
     }
     function normalizeIndex(value) {
       return (value + slides.length) % slides.length;
     }
     function hydrateSlide(slide) {
       if (!slide || slide.getAttribute("data-ccshop7-hydrated") === "true") {
         return;
       }
       var image = slide.querySelector("img");
       if (image) {
         var source = image.getAttribute("data-ccshop7-src");
         var sourceSet = image.getAttribute("data-ccshop7-srcset");
         var sizes = image.getAttribute("data-ccshop7-sizes");
         if (sizes) {
           image.setAttribute("sizes", sizes);
         }
         if (sourceSet) {
           image.setAttribute("srcset", sourceSet);
         }
         if (source) {
           image.setAttribute("src", source);
         }
       }
       var galleryImage = slide.getAttribute("data-ccshop7-gallery-image");
       if (galleryImage) {
         slide.style.setProperty("--cc-gallery-image", galleryImage);
       }
       slide.setAttribute("data-ccshop7-hydrated", "true");
     }
     function showSlide(value, focusThumb) {
       index = normalizeIndex(value);
       hydrateSlide(slides[index]);
       slides.forEach(function (slide, slideIndex) {
         var isActive = slideIndex === index;
         slide.hidden = !isActive;
         slide.classList.toggle("is-active", isActive);
         slide.setAttribute("aria-hidden", isActive ? "false" : "true");
       });
       thumbs.forEach(function (thumb, thumbIndex) {
         var isActive = thumbIndex === index;
         thumb.classList.toggle("is-active", isActive);
         thumb.setAttribute("aria-selected", isActive ? "true" : "false");
         thumb.setAttribute("tabindex", isActive ? "0" : "-1");
       });
       if (current) {
         current.textContent = String(index + 1);
       }
       if (lightbox && lightbox.hasAttribute("open")) {
         updateLightbox();
       }
       if (focusThumb && thumbs[index]) {
         thumbs[index].focus();
       }
     }
     function updateLightbox() {
       if (!lightbox || !lightboxImage) {
         return;
       }
       var activeSlide = slides[index];
       var image = activeSlide.querySelector("img");
       if (!image) {
         return;
       }
       var caption = activeSlide.querySelector("figcaption");
       var fallbackCaption = activeSlide.getAttribute(
         "data-ccshop7-lightbox-caption"
       );
       lightbox.classList.toggle(
         "ccshop7-product-lightbox-paper",
         activeSlide.classList.contains("ccshop7-product-slide-paper")
       );
       lightboxImage.src =
         image.getAttribute("data-ccshop7-lightbox-src") ||
         image.currentSrc ||
         image.src;
        lightboxImage.alt = image.alt || "";
        lightboxImage.width = Number(image.getAttribute("width")) || 1227;
        lightboxImage.height = Number(image.getAttribute("height")) || 1504;
       if (lightboxCaption) {
         lightboxCaption.textContent = caption
           ? caption.textContent
           : fallbackCaption || image.alt || "";
       }
       if (lightboxPosition) {
         lightboxPosition.textContent = lightboxPosition
           .getAttribute("data-ccshop7-position-template")
           .replace("__current__", String(index + 1))
           .replace("__total__", String(slides.length));
       }
     }
     function openLightbox() {
       if (!lightbox || !lightboxImage) {
         return;
       }
       hydrateSlide(slides[index]);
       updateLightbox();
       if (typeof lightbox.showModal === "function") {
         lightbox.showModal();
       } else {
         lightbox.setAttribute("open", "");
       }
       if (closeLightbox) {
         closeLightbox.focus({ preventScroll: true });
       }
     }
     function restoreGalleryFocus() {
       var zoom = slides[index].querySelector("[data-ccshop7-gallery-zoom]");
       if (zoom && zoom.isConnected) {
         zoom.focus({ preventScroll: true });
       }
     }
     function closeDialog() {
       if (!lightbox) {
         return;
       }
       if (typeof lightbox.close === "function") {
         lightbox.close();
       } else {
         lightbox.removeAttribute("open");
         restoreGalleryFocus();
       }
     }
     if (previous) {
       previous.addEventListener("click", function () {
         showSlide(index - 1, false);
       });
     }
     if (next) {
       next.addEventListener("click", function () {
         showSlide(index + 1, false);
       });
     }
     thumbs.forEach(function (thumb) {
       function warmSelectedSlide() {
         var thumbIndex = parseInt(
           thumb.getAttribute("data-ccshop7-gallery-thumb"),
           10
         );
         hydrateSlide(slides[thumbIndex]);
       }
       thumb.addEventListener("click", function () {
         showSlide(
           parseInt(thumb.getAttribute("data-ccshop7-gallery-thumb"), 10),
           false
         );
       });
       thumb.addEventListener("pointerenter", warmSelectedSlide, {
         once: true
       });
       thumb.addEventListener("focus", warmSelectedSlide, {
         once: true
       });
       thumb.addEventListener("keydown", function (event) {
         var thumbIndex = parseInt(
           thumb.getAttribute("data-ccshop7-gallery-thumb"),
           10
         );
         if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
           event.preventDefault();
           showSlide(thumbIndex - 1, true);
         }
         if (event.key === "ArrowRight" || event.key === "ArrowDown") {
           event.preventDefault();
           showSlide(thumbIndex + 1, true);
         }
         if (event.key === "Home") {
           event.preventDefault();
           showSlide(0, true);
         }
         if (event.key === "End") {
           event.preventDefault();
           showSlide(slides.length - 1, true);
         }
       });
     });
     gallery
       .querySelectorAll("[data-ccshop7-gallery-zoom]")
       .forEach(function (button) {
         button.addEventListener("click", openLightbox);
       });
     if (stage) {
       stage.addEventListener("keydown", function (event) {
         if (event.key === "ArrowLeft") {
           event.preventDefault();
           showSlide(index - 1, false);
         }
         if (event.key === "ArrowRight") {
           event.preventDefault();
           showSlide(index + 1, false);
         }
         if (event.key === "Home") {
           event.preventDefault();
           showSlide(0, false);
         }
         if (event.key === "End") {
           event.preventDefault();
           showSlide(slides.length - 1, false);
         }
       });
       stage.addEventListener(
         "touchstart",
         function (event) {
           touchStartX = event.changedTouches[0].clientX;
         },
         { passive: true }
       );
       stage.addEventListener(
         "touchend",
         function (event) {
           if (touchStartX === null) {
             return;
           }
           var difference = event.changedTouches[0].clientX - touchStartX;
           touchStartX = null;
           if (Math.abs(difference) < 42) {
             return;
           }
           showSlide(difference > 0 ? index - 1 : index + 1, false);
         },
         { passive: true }
       );
     }
     if (closeLightbox) {
       closeLightbox.addEventListener("click", closeDialog);
     }
     if (lightboxPrevious) {
       lightboxPrevious.hidden = slides.length < 2;
       lightboxPrevious.addEventListener("click", function () {
         showSlide(index - 1, false);
       });
     }
     if (lightboxNext) {
       lightboxNext.hidden = slides.length < 2;
       lightboxNext.addEventListener("click", function () {
         showSlide(index + 1, false);
       });
     }
     if (lightbox) {
       lightbox.addEventListener("close", restoreGalleryFocus);
       lightbox.addEventListener("keydown", function (event) {
         if (event.altKey || event.ctrlKey || event.metaKey) {
           return;
         }
         var destination;
         if (event.key === "ArrowLeft") destination = index - 1;
         if (event.key === "ArrowRight") destination = index + 1;
         if (event.key === "Home") destination = 0;
         if (event.key === "End") destination = slides.length - 1;
         if (destination !== undefined) {
           event.preventDefault();
           event.stopPropagation();
           showSlide(destination, false);
         }
       });
       lightbox.addEventListener("click", function (event) {
         if (event.target === lightbox) {
           closeDialog();
         }
       });
     }
     showSlide(0, false);
   }

  var activeCard = root.querySelector(".ccshop7-buy-card");
  var initialVariant = activeCard && activeCard.dataset.ccshop7CurrentVariant;
  var variants = new Map();
  var variantData;
  try {
    variantData = JSON.parse(root.querySelector("[data-ccshop7-variant-data]").textContent);
  } catch (_) { variantData = {}; }
  if (activeCard) variants.set(initialVariant, activeCard.cloneNode(true));
  root.querySelectorAll("[data-ccshop7-variant-template]").forEach(function (template) {
    var card = template.content.querySelector(".ccshop7-buy-card");
    if (card) variants.set(template.dataset.ccshop7VariantTemplate, card);
  });
  initializePurchase(root);
  initializeGallery(root);

  function selectVariant(id, href, updateHistory, moveFocus) {
    var current = root.querySelector(".ccshop7-buy-card");
    if (!current || !variants.has(id) || !variantData[id]) return false;
    if (current.dataset.ccshop7CurrentVariant === id) return true;
    var quantity = current.querySelector('input[name="quantity"]');
    var plan = current.querySelector("[data-ccshop7-selling-plan-choice]:checked");
    var next = variants.get(id).cloneNode(true);
    var nextQuantity = next.querySelector('input[name="quantity"]');
    if (quantity && nextQuantity) nextQuantity.value = quantity.value;
    if (plan) {
      var match = Array.from(next.querySelectorAll("[data-ccshop7-selling-plan-choice]"))
        .find(function (choice) { return !choice.disabled && choice.value === plan.value; });
      if (match) match.checked = true;
    }
    var previousNav = current.querySelector(".ccshop7-size-options");
    var previousTop = previousNav ? previousNav.getBoundingClientRect().top : null;
    current.replaceWith(next);
    initializePurchase(next);
    initializeGallery(next);
    root.querySelectorAll("[data-ccshop7-variant-text]").forEach(function (element) {
      var value = variantData[id][element.dataset.ccshop7VariantText];
      if (typeof value === "string") element.textContent = value;
    });
    var equation = root.querySelector("[data-ccshop7-equation]");
    if (equation) equation.setAttribute("aria-label", variantData[id].equation);
    if (updateHistory) {
      var url = new URL(window.location.href);
      var target = new URL(href, window.location.href);
      url.pathname = target.pathname;
      url.searchParams.set("variant", id);
      url.searchParams.delete("section_id");
      window.history.pushState(Object.assign({}, window.history.state, {ccshopVariant: id}), "", url);
    }
    if (moveFocus) {
      var selected = next.querySelector('[data-ccshop7-select-variant="' + id + '"]');
      if (selected) selected.focus({preventScroll: true});
      var nextNav = next.querySelector(".ccshop7-size-options");
      if (previousTop !== null && nextNav) window.scrollBy(0, nextNav.getBoundingClientRect().top - previousTop);
    }
    var status = root.querySelector("[data-ccshop7-variant-status]");
    if (status) {
      var chosenPlan = next.querySelector("[data-ccshop7-selling-plan-choice]:checked");
      status.textContent = variantData[id].announcement + " "
        + (chosenPlan ? chosenPlan.getAttribute("data-ccshop7-plan-label") + "." : variantData[id].oneTime + ".");
    }
    return true;
  }

  root.addEventListener("click", function (event) {
    var link = event.target.closest("[data-ccshop7-select-variant]");
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      if (selectVariant(link.dataset.ccshop7SelectVariant, link.href, true, true)) event.preventDefault();
      return;
    }
    var scrollTrigger = event.target.closest("[data-ccshop7-scroll-buy]");
    if (scrollTrigger) {
      var card = root.querySelector(".ccshop7-buy-card");
      if (!card) return;
      event.preventDefault();
      var options = card.querySelector(".ccshop7-size-options") || card;
      options.scrollIntoView({behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center"});
      var firstOption = options.querySelector("a") || card.querySelector('input[name="quantity"]');
      if (firstOption) firstOption.focus({preventScroll: true});
    }
  });
  window.addEventListener("popstate", function () {
    var id = new URL(window.location.href).searchParams.get("variant") || initialVariant;
    selectVariant(id, window.location.href, false, false);
  });
})();
